var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 16H2.5V14.5H3.25V9.27325C3.25 5.53225 6.2725 2.5 10 2.5C13.7275 2.5 16.75 5.53225 16.75 9.27325V14.5H17.5V16ZM4.75 14.5H15.25V9.27325C15.25 6.361 12.8995 4 10 4C7.1005 4 4.75 6.361 4.75 9.27325V14.5ZM8.125 16.75H11.875C11.875 17.2473 11.6775 17.7242 11.3258 18.0758C10.9742 18.4275 10.4973 18.625 10 18.625C9.50272 18.625 9.02581 18.4275 8.67417 18.0758C8.32254 17.7242 8.125 17.2473 8.125 16.75V16.75Z",
    fill: "#525866"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNotifications);
export default __webpack_public_path__ + "static/media/nav-notifications.9c1c5b574602230dc3e712de31a83820.svg";
export { ForwardRef as ReactComponent };